import React, { useEffect, useRef, useState } from "react";
import "../../../src/common.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { logoutUser } from "../../hooks/services/services";
import { useAccess } from "../../context/AccessContext";
import { SIDEBAR_ITEMS } from "../../config/accessControl";
import { requestPageTour } from "../../components/onboarding/FirstRunTour";
import { logger } from "../../utils/logger";

const pageTitleForPath = (pathname) => {
  const exact = SIDEBAR_ITEMS.find((item) => item.path === pathname);
  if (exact?.label) return exact.label;
  const nested = SIDEBAR_ITEMS.find(
    (item) => item.path !== "/" && pathname.startsWith(`${item.path}/`)
  );
  return nested?.label || "Dashboard";
};

const Header = ({ drawerClick, sidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { clearAccessContext, username, email, roleName: accessRoleName } = useAccess();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const pageTitle = pageTitleForPath(location.pathname);
  const programName = searchParams.get("programName") || "";
  const displayName = username || email || "Account";
  const roleName = accessRoleName || localStorage.getItem("userRole") || "";

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onPointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    try {
      const res = await logoutUser();
      if (res) {
        clearAccessContext();
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      logger.error("Error during logout:", error)
    }
  };

  return (
    <div className="top-bar">
      <div className="top-left">
        <button
          type="button"
          className="header-menu-toggle"
          onClick={drawerClick}
          aria-label={sidebarOpen ? "Collapse navigation" : "Expand navigation"}
          aria-expanded={Boolean(sidebarOpen)}
        >
          <img src="../images/side_menu-icn.png" alt="" className="side_menu_work image-hover" />
        </button>
        <div className="header-context" data-tour="page-intro">
          <p className="header-page-title">{pageTitle}</p>
          {programName && <p className="header-program-name">{programName}</p>}
        </div>
      </div>
      <div className="top-right">
        <div className="user-prt header-user-menu" ref={menuRef} data-tour="user-menu">
          <button
            type="button"
            className="header-user-button"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setMenuOpen((open) => !open);
            }}
          >
            <span className="header-user-email">
              {displayName}
              <span className="header-user-caret" aria-hidden="true">
                {menuOpen ? "▲" : "▼"}
              </span>
            </span>
            {roleName && <span className="header-user-role">{roleName}</span>}
          </button>
          {menuOpen && (
            <ul className="header-user-dropdown drpdwn_usr" role="menu">
              <li role="none">
                <button
                  type="button"
                  role="menuitem"
                  onClick={() => {
                    setMenuOpen(false);
                    requestPageTour();
                  }}
                >
                  Walk through this page
                </button>
              </li>
              <li role="none">
                <button type="button" role="menuitem" onClick={handleLogout}>
                  Log out
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
